import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, CheckCircle } from "@phosphor-icons/react";
import { Footer } from "@/components/site/Footer";

const GHL_SCRIPT = "https://link.mobyle.agency/js/form_embed.js";

const PERKS = [
  "A written blueprint: features, automations, timeline & price",
  "Straight answers — no jargon, no obligation",
  "You own everything we build. No lock-in.",
];

export default function Book() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!document.querySelector(`script[src="${GHL_SCRIPT}"]`)) {
      const s = document.createElement("script");
      s.src = GHL_SCRIPT;
      s.async = true;
      document.body.appendChild(s);
    }
  }, []);

  // GHL booking widget broadcasts "msgsndr-booking-complete" when a slot is booked
  useEffect(() => {
    const onMessage = (event) => {
      const d = event.data;
      const done =
        (Array.isArray(d) && d[0] === "msgsndr-booking-complete") ||
        (typeof d === "string" && d.includes("msgsndr-booking-complete")) ||
        (d && typeof d === "object" && d.type === "msgsndr-booking-complete");
      if (done) navigate("/thank-you");
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, [navigate]);

  return (
    <div className="relative min-h-screen bg-[#05050c]" data-testid="book-page">
      <header className="sticky top-0 z-50 border-b border-white/10 bg-[#05050c]/85 backdrop-blur-xl">
        <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="book-logo-home">
            <img src="/mobyle-logo.png" alt="Mobyle" className="h-9 w-auto object-contain" />
            <span className="font-heading font-extrabold text-xl tracking-tight text-white">Mobyle</span>
          </Link>
          <Link
            to="/"
            className="group inline-flex items-center gap-2 text-sm text-white/60 hover:text-teal transition-colors duration-300"
            data-testid="book-back-home"
          >
            <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform duration-300" />
            Back to home
          </Link>
        </div>
      </header>

      <main className="relative max-w-5xl mx-auto px-6 py-16 md:py-20">
        <div className="absolute inset-0 -z-0 bg-[radial-gradient(circle_at_20%_10%,rgba(64,224,208,0.12),transparent_40%),radial-gradient(circle_at_85%_30%,rgba(139,92,246,0.14),transparent_45%)] pointer-events-none" />
        <div className="relative text-center max-w-2xl mx-auto">
          <span className="text-xs uppercase tracking-[0.25em] text-teal/80">Book a call</span>
          <h1 className="mt-5 font-heading font-extrabold tracking-tighter text-white text-4xl sm:text-5xl md:text-6xl leading-[0.98]">
            Book your free build consult.
          </h1>
          <p className="mt-6 text-white/60 leading-relaxed">
            Pick a time that works for you. You talk, we listen — and you walk away
            with a clear plan for what to build and what it takes.
          </p>
          <ul className="mt-8 flex flex-col sm:flex-row sm:flex-wrap items-start sm:items-center justify-center gap-3 sm:gap-5 text-left">
            {PERKS.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-white/70 max-w-xs">
                <CheckCircle size={18} weight="fill" className="text-teal shrink-0 mt-0.5" />
                {p}
              </li>
            ))}
          </ul>
        </div>

        <div
          className="relative mt-12 rounded-2xl border border-white/10 bg-transparent overflow-hidden shadow-glow-teal"
          data-testid="booking-widget"
        >
          <iframe
            src="https://link.mobyle.agency/widget/booking/3P29PEoVAkH77BsHHKys"
            allow="payment"
            scrolling="no"
            title="Book a call with Mobyle"
            id="3P29PEoVAkH77BsHHKys_book"
            style={{ width: "100%", minHeight: "760px", border: "none", overflow: "hidden" }}
          />
        </div>
      </main>

      <Footer />
    </div>
  );
}
